import { VirtualExperienceCore, VirtualExperienceWrapperProps } from './virtual-experience-core';
import { LoadingSpinner } from '@cue/atoms';
import { IConfigDto } from '@cuevideostory/core';
import { VirtualTourConfigSource } from '@cuevideotour/core';
import { VideoStoryWayPoints } from '@cuevideowaypoints/core';

import { fetchVideoStoryData } from '@project/cue-api/virtual-experience/fetch-video-story';
import {
  ShowroomTopics,
  createVideoTopics,
} from '@project/cue-api/virtual-experience/fetch-video-story-topics';
import { fetchWaypoints } from '@project/cue-api/virtual-experience/fetch-video-story-waypoints';
import { fetchTourData } from '@project/cue-api/virtual-experience/fetch-virtual-tours';

import { useEffect, useState } from 'react';
import videoStoryData from '@project/local/video-story.json';
import videoTourData from '@project/local/virtual-tours.json';
import videoTopicsData from '@project/local/video-app-topics.json';
import videoWaypointsData from '@project/local/video-app-waypoints.json';
export const VirtualExperience = (props: VirtualExperienceWrapperProps) => {
  const useLiveData = Boolean(process.env.SHOWROOM_LIVE_DATA);
  const [loading, setLoading] = useState<boolean>(useLiveData);
  const [videoConfigJSON, setVideoConfigJSON] = useState<IConfigDto | null>(
    !useLiveData ? (videoStoryData as unknown as IConfigDto) : null,
  );
  const [tourConfigJSON, setTourConfigJSON] = useState<unknown | null>(
    !useLiveData ? videoTourData : null,
  );
  const [videoTopicsJSON, setVideoTopicsJSON] = useState<ShowroomTopics[] | null>(
    !useLiveData ? (videoTopicsData as unknown as ShowroomTopics[]) : null,
  );

  const [videoWaypointsJSON, setVideoWaypointsJSON] = useState<VideoStoryWayPoints | null>(
    !useLiveData ? (videoWaypointsData as unknown as VideoStoryWayPoints) : null,
  );

  const getData = async () => {
    const videoStoryData = await fetchVideoStoryData();

    setVideoConfigJSON(videoStoryData);

    const tourData = await fetchTourData();
    setTourConfigJSON(tourData);

    const topicsData = await createVideoTopics();
    setVideoTopicsJSON(topicsData);

    const waypoints = await fetchWaypoints();
    setVideoWaypointsJSON(waypoints);

    setLoading(false);
  };

  useEffect(() => {
    if (useLiveData) getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadingOrDataNotReady =
    loading || !videoConfigJSON || !tourConfigJSON || !videoTopicsJSON || !videoWaypointsJSON;

  return loadingOrDataNotReady ? (
    <div className="virtual-experience-loading">
      <LoadingSpinner />
    </div>
  ) : (
    <VirtualExperienceCore
      {...props}
      videoConfigJSON={videoConfigJSON as unknown as IConfigDto}
      tourConfigJSON={tourConfigJSON as unknown as VirtualTourConfigSource}
      videoTopicsJSON={videoTopicsJSON || []}
      videoWaypointsJSON={videoWaypointsJSON as unknown as VideoStoryWayPoints[]}
    />
  );
};
